"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _OccurrenceItem = _interopRequireDefault(require("./OccurrenceItem"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.occurrence-list {\n  display: flex;\n  flex-direction: column;\n  width: 100vw;\n  width: 100%; }\n\n.occurrence-item {\n  width: 100vw;\n  max-width: 100%; }\n  .occurrence-item.no-hover {\n    background-color: unset;\n    cursor: default; }\n    .occurrence-item.no-hover:hover {\n      background-color: unset; }\n  .occurrence-item a {\n    text-decoration: none; }\n  .occurrence-item .occurrence-row {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    gap: 16px;\n    width: 100%; }\n  .occurrence-item .info {\n    width: 95px;\n    justify-content: flex-start; }\n\n.occurrence-item:hover {\n  background-color: #f4f4f4; }\n\n@media (max-width: 42rem) {\n  .occurrence-list {\n    display: flex;\n    flex-direction: column;\n    width: 100vw;\n    width: 100%; }\n  .occurrence-item {\n    width: 100vw;\n    max-width: 100%; }\n    .occurrence-item a {\n      text-decoration: none; }\n    .occurrence-item .occurrence-row {\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n      gap: 16px;\n      width: 100%; } }\n";
  const fileName = "OccurrenceList_OccurrenceList";
  const element = document.querySelector("style[data-sass-component='OccurrenceList_OccurrenceList']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const OccurrenceList = _ref => {
  let {
    eventCode,
    eventOccurrences,
    lang,
    translate
  } = _ref;
  const sortedOccurrences = [...eventOccurrences].sort((a, b) => {
    if (a.title === eventCode && b.title !== eventCode) return -1;
    if (b.title === eventCode && a.title !== eventCode) return 1;
    return a.title.localeCompare(b.title);
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "occurrence-list sia-border-01-top"
  }, sortedOccurrences.map((event, i) => /*#__PURE__*/_react.default.createElement(_OccurrenceItem.default, {
    key: i,
    current_event_code: eventCode,
    event_code: event.title,
    evenito_link: event.evenito_link,
    date_times: event.date_times,
    lang: lang,
    translate: translate
  })));
};
var _default = exports.default = OccurrenceList;